import ga from '../utils/ga'
import { ILocationParams } from '../utils/location/types'

export const reportPageView = () => {
  if (typeof document === 'undefined') {
    return
  }
  ga('send', {
    hitType: 'pageview',
    title: document.title
  })
  ga('set', {
    referrer: null
  })
}

export const reportRouteChange = () => {
  const dataLayer = (window as any).dataLayer as [{}]
  dataLayer.push({
    event: 'routeChange'
  })
}

export const reportPageType = (pageType: string) => {
  const newrelic = (window as any).newrelic
  if (newrelic) {
    newrelic.interaction().setAttribute('pageType', pageType)
  }
  ga('set', 'dimension20', pageType)
}

export const reportSearchPageType = (locationParams: ILocationParams) => {
  if (locationParams.category && !locationParams.tags && !locationParams.term) {
    reportPageType('category')
  } else {
    reportPageType('search')
  }
}

export const reportPerformanceMetrics = (metrics: any) => {
  const newrelic = (window as any).newrelic
  if (newrelic) {
    newrelic.addPageAction('performanceMeasurement', metrics)
  }
}
